import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function AudienceSplitSection() {
  const { t } = useTranslation();
  return (
    <section className="relative py-20 md:py-28 bg-primary-900">
      <div className="max-w-[1280px] mx-auto px-6 sm:px-8 md:px-12 lg:px-16">
        <div className="text-center mb-14">
          {String(t('home.audienceSplit.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-400 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-50 tracking-[0.06em] mb-4">
            {t('home.audienceSplit.title')}
          </h2>
          <div className="gold-line mx-auto mb-4"></div>
          {String(t('home.audienceSplit.subtitle')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] text-foreground-300 tracking-[0.04em] max-w-2xl mx-auto leading-relaxed">{__s}</p>))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {/* Personal Card */}
          <div className="group bg-background-50 border border-background-200/60 hover:border-accent-500/30 transition-all duration-300 overflow-hidden">
            <div className="relative h-56 md:h-64 overflow-hidden">
              <img
                src="/images/generated/about-classroom-2026.jpg"
                alt={t('home.audienceSplit.personal.imgAlt')}
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-primary-900/10"></div>
              <div className="absolute top-4 left-4 bg-accent-500/90 text-primary-900 text-[12px] tracking-[0.1em] font-bold px-3 py-1.5">
                {t('home.audienceSplit.personal.tag')}
              </div>
            </div>
            <div className="p-7 md:p-9">
              {String(t('home.audienceSplit.personal.tagEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-500/70 text-[13px] tracking-[0.14em] mb-3">{__s}</p>))}
              <h3 className="font-heading text-[20px] md:text-[23px] text-foreground-900 tracking-[0.04em] mb-4">
                {t('home.audienceSplit.personal.title')}
              </h3>
              {String(t('home.audienceSplit.personal.desc')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[15px] text-foreground-600 tracking-[0.03em] leading-relaxed mb-5">{__s}</p>))}
              <ul className="space-y-2 mb-7">
                {[1, 2, 3].map((n) => (
                  <li key={n} className="flex items-start gap-2.5 text-[14px] text-foreground-700 tracking-[0.02em]">
                    <i className="ri-checkbox-circle-fill text-accent-500 text-base mt-0.5 flex-shrink-0"></i>
                    <span>{t(`home.audienceSplit.personal.point${n}`)}</span>
                  </li>
                ))}
              </ul>
              <Link
                to="/personal"
                className="btn-glow inline-flex items-center gap-3 px-8 py-3.5 bg-accent-500/90 hover:bg-accent-500 text-primary-900 text-[15px] tracking-[0.1em] font-medium transition-all duration-300 whitespace-nowrap"
              >
                {t('home.audienceSplit.personal.cta')}
                <i className="ri-arrow-right-line text-sm"></i>
              </Link>
            </div>
          </div>

          {/* Corporate Card */}
          <div className="group bg-background-50 border border-background-200/60 hover:border-accent-500/30 transition-all duration-300 overflow-hidden">
            <div className="relative h-56 md:h-64 overflow-hidden">
              <img
                src="/images/generated/corporate-hero-2026.jpg"
                alt={t('home.audienceSplit.corporate.imgAlt')}
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-primary-900/10"></div>
              <div className="absolute top-4 left-4 bg-accent-500/90 text-primary-900 text-[12px] tracking-[0.1em] font-bold px-3 py-1.5">
                {t('home.audienceSplit.corporate.tag')}
              </div>
            </div>
            <div className="p-7 md:p-9">
              {String(t('home.audienceSplit.corporate.tagEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-500/70 text-[13px] tracking-[0.14em] mb-3">{__s}</p>))}
              <h3 className="font-heading text-[20px] md:text-[23px] text-foreground-900 tracking-[0.04em] mb-4">
                {t('home.audienceSplit.corporate.title')}
              </h3>
              {String(t('home.audienceSplit.corporate.desc')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[15px] text-foreground-600 tracking-[0.03em] leading-relaxed mb-5">{__s}</p>))}
              <ul className="space-y-2 mb-7">
                {[1, 2, 3].map((n) => (
                  <li key={n} className="flex items-start gap-2.5 text-[14px] text-foreground-700 tracking-[0.02em]">
                    <i className="ri-checkbox-circle-fill text-accent-500 text-base mt-0.5 flex-shrink-0"></i>
                    <span>{t(`home.audienceSplit.corporate.point${n}`)}</span>
                  </li>
                ))}
              </ul>
              <Link
                to="/corporate"
                className="btn-glow inline-flex items-center gap-3 px-8 py-3.5 bg-accent-500/90 hover:bg-accent-500 text-primary-900 text-[15px] tracking-[0.1em] font-medium transition-all duration-300 whitespace-nowrap"
              >
                {t('home.audienceSplit.corporate.cta')}
                <i className="ri-arrow-right-line text-sm"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
